import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { firestore } from '../../../config/firebase';
import { createNotification } from '../../../store/actions/notificationActions';
import { updateProduct } from '../../../store/actions/productActions';
import { updateSale } from '../../../store/actions/saleActions';
import { pulse } from '../../../assets/js/global.methods';
import { FiDownload, FiGift, FiX, FiEdit, FiEdit2 } from 'react-icons/fi';
import Swal from 'sweetalert2';
import Receipt from '../../UIComponents/Receipt';
import ReactToPrint from 'react-to-print';
import lang from '../lang';
import { FaUniversity, FaCreditCard, FaHandHoldingUsd, FaMoneyBill, FaRandom, FaDollarSign, FaSlash } from 'react-icons/fa';
import defaultImg from '../../../assets/img/default/carpet.svg';
// import { ReactComponent as Logo } from '../../../assets/img/icons/banking.svg';
import '../NewSale/NewSale.css';

class NewSale extends Component {
    state = {
        progress: 0,
        msg: '',
        msgStatus: false,
        msgType: 'success',
        note: '',
        noteBtn: false,
        salePrice: 0,
        piecesForSale: 1,
        totalValue: 0,
        paymentType: 'cash',
        productId: '',
        paymentStatus: 'paid',
        active: false,
        roll: 0,
        rollLength: 0,
        toggleMixedPayment: false,
        mixedPaymentReadOnly: true,
        toggleSalePage: {
            sale: true,
            payment: false
        },
        tab: {
            sale: true,
            detail: false
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        const currentSale = this.props.sales.find((item) => {
            return item.id === id
        })
        const currentProduct = this.props.products.find((item) => {
            return item.id === currentSale.productId
        });

        ['cash', 'card', 'bank', 'mixed'].forEach(item => {
            if (item === currentSale.paymentType) {
                this[item + 'Ref'].classList.add('active');
                if (item === 'mixed') {
                    this.setState({ toggleMixedPayment: true, });
                }
            }
        });
        ['paid', 'debt', 'bonus', 'canceled'].forEach(item => {
            if (item === currentSale.paymentStatus) {
                this[item + 'Ref'].classList.add('active')
            }
        });

        if (currentProduct) {
            this.setState({ id, ...currentSale, salePrice: parseFloat(currentSale.salePrice).toFixed(2), totalValue: parseFloat(currentSale.totalValue).toFixed(2), piece: currentProduct.piece, updatedAt: Date.now() });
        } else {
            this.setState({ id, ...currentSale, salePrice: parseFloat(currentSale.salePrice).toFixed(2), totalValue: parseFloat(currentSale.totalValue).toFixed(2), updatedAt: Date.now() });
        }
    }

    alertMessageHandler = () => {
        this.setState({ msgStatus: false });
    }

    // ======== Mixed Payment Handlers ===================

    // ===> Update input filed and call Mixed payment handler
    mixedPaymentAmountHandler = (e) => {
        const { name, value } = e.target;
        if (this.state.dueAmount > 0) {
            this.setState({ [name]: value }, () => this.mixedPaymentHandler(this[name + 'Ref']));
            e.target.classList.remove('error-input');
        } else {
            e.target.classList.add('error-input');
            this.setState({ [name]: value }, () => this.mixedPaymentHandler(this[name + 'Ref']));
        }
    }

    // ===> Mixed payment handler for remaning Due amount
    mixedPaymentHandler = (ref) => {
        const { totalValue, mixedPaymentCash, mixedPaymentCard, mixedPaymentBank } = this.state;
        const dueAmount = parseFloat((totalValue - mixedPaymentCash - mixedPaymentCard - mixedPaymentBank) * 100).toFixed(2) / 100;

        if (dueAmount > 0) {
            this.setState({ dueAmount: dueAmount });
            if (ref) {
                ref.classList.remove('error-input');
            }
        } else if (dueAmount === 0) {
            this.setState({ dueAmount: dueAmount, mixedPaymentReadOnly: true });
            this.mixedPaymentBankRef.classList.remove('error-input')
            this.mixedPaymentCardRef.classList.remove('error-input')
            this.mixedPaymentCashRef.classList.remove('error-input')
        } else {
            this.setState({ dueAmount: dueAmount });
            if (ref) {
                ref.classList.add('error-input')
            }
        }
    }

    // If mixed amount inputs are readOnly = true , Make theme editable
    mixedPaymentReadOnlyHandler = () => {
        this.setState({ mixedPaymentReadOnly: false });
    }

    inputHandler = (e) => {
        const { name, value } = e.target;
        if (name === 'width' || name === 'lengthLong') {
            this.setState({ [name]: value }, () => {
                const { width, lengthLong } = this.state;
                this.setState({ totalSize: width * lengthLong });
            });
        } else if (name === 'paymentType') {
            ['cash', 'card', 'bank', 'mixed'].forEach(item => {
                console.log(this[item + 'Ref'])
                if (item !== value) {
                    this[item + 'Ref'].classList.remove('active');
                } else {
                    e.target.classList.add('active');
                }
                if (value === 'mixed') {
                    this.setState({
                        toggleMixedPayment: true,
                        dueAmount: this.state.dueAmount >= 0 ? 0 : this.state.totalValue,
                        mixedPaymentBank: this.state.mixedPaymentBank || 0,
                        mixedPaymentCard: this.state.mixedPaymentCard || 0,
                        mixedPaymentCash: this.state.mixedPaymentCash || 0
                    });
                } else {
                    this.setState({ toggleMixedPayment: false, dueAmount: 0 });
                }
            });
            this.setState({ [name]: value });
        } else if (name === 'paymentStatus') {
            ['paid', 'debt', 'bonus', 'canceled'].forEach(item => {
                if (item !== value) {
                    this[item + 'Ref'].classList.remove('active');
                } else {
                    e.target.classList.add('active');
                }
            });
            if (value === 'debt') {
                const { dueAmount, totalValue, paymentType } = this.state
                if (paymentType === 'mixed' && dueAmount > 0) {
                    this.setState({ customerDebtAmount: dueAmount });
                } else {
                    this.setState({ customerDebtAmount: totalValue, dueAmount: totalValue });
                }
            }
            this.setState({ [name]: value });
        } else if (name === 'category') {
            this.setState({ [name]: value }, () => {
                if (value !== 'carpet') {
                    this.totalSizeInput.style.display = "none"
                    this.widthInput.style.display = "none"
                } else {
                    this.totalSizeInput.style.display = "block"
                    this.widthInput.style.display = "block"
                }
            });
        } else {
            this.setState({ [name]: value });
        }
    }

    salePriceHandler = (e) => {
        if (Math.abs(e.target.value) < Math.abs(e.target.min)) {
            e.target.classList.add('error-input');
            const price = this.props.user.currency === 'UZS' ? parseFloat((this.state.piecesForSale * this.state.merchantPrice * this.state.totalSize) * this.props.user.uzsAmount).toFixed(2) : parseFloat(this.state.piecesForSale * this.state.merchantPrice * this.state.totalSize).toFixed(2)
            this.setState({
                salePrice: price,
                totalValue: price
            }, () => this.mixedPaymentHandler());
        } else {
            e.target.classList.remove('error-input');
            this.setState({
                salePrice: e.target.value,
                totalValue: parseFloat(this.state.piecesForSale * e.target.value).toFixed(2)
            }, () => this.mixedPaymentHandler());
        }
    }

    piecesHandler = (e, value) => {
        const { piecesForSale, piece, rollLength } = this.state;
        // Pulse effect 
        pulse(e);
        if (value === 'decrement' && piecesForSale > 0) {
            if (this.state.category !== 'carpet') {
                const countRoll = Math.ceil((piece + 1) / rollLength);
                this.setState(prevState => {
                    return {
                        piecesForSale: prevState.piecesForSale - 1,
                        totalValue: parseFloat(prevState.salePrice * (prevState.piecesForSale - 1)).toFixed(2),
                        piece: prevState.piece + 1,
                        active: true,
                        roll: countRoll
                    }
                }, () => this.mixedPaymentHandler());
            } else {
                this.setState(prevState => {
                    return {
                        piecesForSale: prevState.piecesForSale - 1,
                        totalValue: parseFloat(prevState.salePrice * (prevState.piecesForSale - 1)).toFixed(2),
                        piece: prevState.piece + 1,
                        active: true
                    }
                }, () => this.mixedPaymentHandler());
            }

        }
        if (value === 'increment' && piece !== 0) {
            if (this.state.category !== 'carpet') {
                const countRoll = Math.ceil((piece - 1) / rollLength);
                this.setState(prevState => {
                    return {
                        piecesForSale: prevState.piecesForSale + 1,
                        totalValue: parseFloat(prevState.salePrice * (prevState.piecesForSale + 1)).toFixed(2),
                        piece: prevState.piece - 1,
                        active: true,
                        roll: countRoll
                    }
                }, () => this.mixedPaymentHandler());
            } else {
                this.setState(prevState => {
                    return {
                        piecesForSale: prevState.piecesForSale + 1,
                        totalValue: parseFloat(prevState.salePrice * (prevState.piecesForSale + 1)).toFixed(2),
                        piece: prevState.piece - 1,
                        active: true
                    }
                }, () => this.mixedPaymentHandler());
            }

        }

    }

    customerHandler = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    formhandler = (e) => {
        e.preventDefault();
        const currentProduct = this.props.products.find(item => item.id === this.state.productId)
        const currentSale = this.props.sales.find(item => item.id === this.state.id);

        const {
            progress,
            msg,
            msgStatus,
            msgType,
            id,
            piece,
            tab,
            noteBtn,
            dueAmount,
            toggleMixedPayment,
            toggleSalePage,
            mixedPaymentReadOnly,
            mixedPaymentBank,
            mixedPaymentCard,
            mixedPaymentCash,
            ...data } = this.state;

        // If price is not in USD
        const currencyBasedData = this.props.user.currency === 'UZS' && data.paymentStatus !== 'canceled' ?
            {
                exchange: true,
                profit: parseInt(data.totalValue - (data.totalFactoryPrice * this.props.user.uzsAmount)),
                profitAfterExchange: parseFloat((data.totalValue / this.props.user.uzsAmount) - data.totalFactoryPrice).toFixed(2),
                salePriceAfterExchange: parseFloat(data.totalValue / this.props.user.uzsAmount).toFixed(2),
            }
            :
            {
                exchange: false,
                profit: parseInt(data.totalValue - (data.totalFactoryPrice)),
                profitAfterExchange: parseFloat((data.totalValue) - data.totalFactoryPrice).toFixed(2),
                salePriceAfterExchange: parseFloat(data.totalValue).toFixed(2),
            }


        // create new sales
        let updatedData = {};
        if (data.paymentType === 'mixed') {
            updatedData = { ...data, ...currencyBasedData, mixedPaymentBank, mixedPaymentCard, mixedPaymentCash, dueAmount }
        } else if (data.paymentStatus === 'canceled') {
            updatedData = { ...data, ...currencyBasedData, piecesForSale: 0, totalValue: 0, salePrice: 0, profit: 0, salePriceAfterExchange: 0, profitAfterExchange: 0 };
        } else {
            updatedData = { ...data, ...currencyBasedData };
        }
        firestore.collection('users')
            .doc(this.state.userId)
            .collection('sales')
            .doc(id)
            .set({ ...updatedData })
            .then(doc => {

                if (currentSale.piecesForSale !== updatedData.piecesForSale) {

                    const productPieces = currentProduct.piece + (currentSale.piecesForSale - updatedData.piecesForSale);

                    if (currentProduct) {
                        // update the product piece 
                        firestore.collection('users')
                            .doc(this.state.userId)
                            .collection('products')
                            .doc(data.productId)
                            .update({ piece: productPieces });

                        // update the products reducer 
                        this.props.updateProduct({
                            ...currentProduct,
                            piece: productPieces
                        });

                        if (productPieces <= data.alertNumber) {
                            firestore.collection('users')
                                .doc(this.state.userId)
                                .collection('notifications')
                                .add({
                                    active: true,
                                    productId: currentProduct.id,
                                    piece: productPieces,
                                    msg: 'You have a few items left in the storage. Please, bring some more items',
                                    archive: false,
                                    createdAt: Date.now()
                                }).then(doc => {
                                    this.props.createNotification({
                                        id: doc.id,
                                        active: true,
                                        productId: currentProduct.id,
                                        piece: productPieces,
                                        msg: 'You have a few items left in the storage. Please, bring some more items',
                                        archive: false,
                                        createdAt: Date.now()
                                    })
                                })
                        }

                    }
                }

                // If sale is debt set notification time
                if (this.state.paymentStatus === 'debt') {
                    axios({
                        url: '/users/cron-job',
                        method: 'post',
                        data: {
                            uid: this.state.userId,
                            saleId: id,
                            date: this.state.customerPayDeadline
                        }
                    }).then(res => {
                        console.log(res)
                    }).catch(err => console.log(err))
                }
                this.props.updateSale({ id, ...updatedData, ...currencyBasedData });
            });

        e.target.style.display = 'none';
        // this.printerRef.triggerRef.click();
        // setTimeout(() => this.props.history.push('/sales'), 2000);
        Swal.fire({
            type: 'success',
            title: 'Sold Successfully',
            showConfirmButton: false,
            timer: 1500
        });
        setTimeout(() => this.props.history.push('/sales'), 2000)
    }

    toggleSaleDetailsTab = (event) => {
        const { name } = event.target;
        const data = name === 'sale' ? 'details' : 'sale';

        this.setState(prevState => {
            return { tab: { [name]: true, [data]: false } }
        });
    }

    toggleSalePage = (event) => {
        const { name } = event.target;
        const data = name === 'sale' ? 'payment' : 'sale';

        this.setState(prevState => {
            return { toggleSalePage: { [name]: false, [data]: true } }
        });
    }

    toggleNoteDetails = () => {
        this.setState(prevState => {
            return { noteBtn: !prevState.noteBtn }
        });
    }

    render() {
        const { tab: { sale, detail } } = this.state;
        const {
            design,
            quality,
            title,
            category,
            color,
            dimension,
            total,
            importPrice,
            salePrice,
            inStock,
            info,
            buttons: { saleBtn },
            sale: {
                saleTab, detailTab, paymentTitle, paymentTitle2, paymentTitle3, nextBtn, backBtn, cash, card, bank, mixed, paid, debt, bonus, canceled, due, dueChange, noteText, button,
                customer: { ctTitle, ctName, ctDue, ctPhone, ctAddress }
            }
        } = lang[this.props.user.lang || 'en'];


        const { currency, uzsAmount } = this.props.user;
        const minItemSalePrice = currency === 'UZS' ? parseInt(this.state.totalValue) : parseFloat(this.state.totalMerchantPrice).toFixed(2);

        return (

            <div className="container mt-5 mb-5 pb-5">
                <div
                    className={`alert alert-${this.state.msgType}`}
                    style={{ display: this.state.msgStatus ? 'block' : 'none' }}
                >
                    {this.state.msg}
                    <button type="button" className="close" onClick={() => this.alertMessageHandler()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                {/* <Link to="/sales" className="btn btn-info">Go Back Sales</Link> */}
                <div id="new-sale" className="bg-white text-center">
                    {/* =======  Left side of the ui   ======= */}
                    <div id="sale-left" className={`pt-5 ${this.state.toggleSalePage.sale ? 'show-sale' : 'hide-sale'}`}>
                        <div id="sale-img-wrapper">
                            <span className="badge badge-pill badge-success"><FiDownload /> {this.state.piece}</span>
                            <img src={this.state.img || defaultImg} onError={(e) => e.target.src = defaultImg} alt="carpet" />
                        </div>
                        <div className="my-4 count-wrapper">
                            <div className="count-btn btn" onClick={(e) => this.piecesHandler(e, 'decrement')}>-</div>
                            <h3 className="count-number">{this.state.piecesForSale}</h3>
                            <div className="count-btn btn" onClick={(e) => this.piecesHandler(e, 'increment')}>+</div>
                        </div>
                        <div className="price input-group">
                            {/* <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon1">{this.props.user.currency}</span>
                            </div> */}
                            <input
                                type="tel"
                                name="salePrice"
                                className="form-control text-center"
                                min={minItemSalePrice || 0}
                                defaultValue={this.state.salePrice || this.state.totalMerchantPrice}
                                onChange={(event) => this.salePriceHandler(event)}
                                onBlur={(e) => e.target.value = Math.abs(e.target.value) < minItemSalePrice ? minItemSalePrice : Math.abs(e.target.value)}
                            />
                        </div>
                        <button
                            id="sale-page-next"
                            className="btn btn-sm btn-outline-success"
                            name="sale"
                            onClick={(e) => this.toggleSalePage(e)}
                        >{nextBtn} =></button>
                    </div>
                    {/* =======  Sale right side   ======= */}
                    <div id="sale-right" className={`${this.state.toggleSalePage.payment ? 'show-sale' : 'hide-sale'}`}>
                        <ul className="nav nav-tabs mb-3" id="myTab" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${sale ? 'active' : ''}`}
                                    name="sale"
                                    onClick={this.toggleSaleDetailsTab}
                                >{saleTab}</button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${detail ? 'active' : ''}`}
                                    name="detail"
                                    onClick={this.toggleSaleDetailsTab}
                                >{detailTab}</button>
                            </li>
                        </ul>

                        <div id="sale-details" style={{ display: sale ? 'block' : 'none' }}>
                            <h5>{paymentTitle}</h5>
                            <div className="form-group payment-type mt-3 mb-3">
                                <button
                                    value="cash"
                                    name="paymentType"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.cashRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FaMoneyBill /> {cash}</button>

                                <button
                                    value="card"
                                    name="paymentType"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.cardRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FaCreditCard /> {card}</button>

                                <button
                                    value="bank"
                                    name="paymentType"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.bankRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FaUniversity /> {bank}</button>

                                <button
                                    value="mixed"
                                    name="paymentType"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.mixedRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FaRandom /> {mixed}</button>
                            </div>

                            <div style={{ display: this.state.toggleMixedPayment ? 'block' : 'none' }} id="mp-wrapper">
                                <p>{due}: <b className={`text-${Math.sign(this.state.dueAmount) !== -1 && this.state.dueAmount > 0 ? 'danger' : 'success'}`}>{this.state.dueAmount} <sup>{this.props.user.currency}</sup></b></p>
                                <div className="my-3">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FaMoneyBill /> </span>
                                        </div>
                                        <input
                                            min="0"
                                            type="number"
                                            className="form-control"
                                            name="mixedPaymentCash"
                                            readOnly={this.state.mixedPaymentReadOnly}
                                            defaultValue={this.state.mixedPaymentCash}
                                            ref={(ref) => this.mixedPaymentCashRef = ref}
                                            onChange={(e) => this.mixedPaymentAmountHandler(e)}
                                            onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                        />
                                    </div>
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FaCreditCard /></span>
                                        </div>
                                        <input
                                            min="0"
                                            type="number"
                                            className="form-control"
                                            name="mixedPaymentCard"
                                            readOnly={this.state.mixedPaymentReadOnly}
                                            defaultValue={this.state.mixedPaymentCard}
                                            ref={(ref) => this.mixedPaymentCardRef = ref}
                                            onChange={(e) => this.mixedPaymentAmountHandler(e)}
                                            onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                        />
                                    </div>
                                    <div className="input-group mb-3 border-secondary">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text" id="basic-addon1"><FaUniversity /></span>
                                        </div>
                                        <input
                                            min="0"
                                            type="number"
                                            className="form-control"
                                            name="mixedPaymentBank"
                                            readOnly={this.state.mixedPaymentReadOnly}
                                            defaultValue={this.state.mixedPaymentBank}
                                            ref={(ref) => this.mixedPaymentBankRef = ref}
                                            onChange={(e) => this.mixedPaymentAmountHandler(e)}
                                            onInput={(e) => e.target.value = Math.abs(e.target.value)}
                                        />
                                    </div>
                                    <button id="mp-readonly" onClick={this.mixedPaymentReadOnlyHandler} className="btn btn-outline-secondary btn-sm">{dueChange} <FiEdit2 /></button>
                                </div>

                            </div>
                            <h5>{paymentTitle2}</h5>
                            <div className="form-group payment-status mt-3 mb-3">
                                <button
                                    value="paid"
                                    name="paymentStatus"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.paidRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FaHandHoldingUsd /> {paid}</button>

                                <button
                                    value="debt"
                                    name="paymentStatus"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.debtRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                >
                                    <span className="debt">
                                        <FaDollarSign />
                                        <FaSlash className="slash" />
                                    </span>
                                    {debt}
                                </button>

                                <button
                                    value="bonus"
                                    name="paymentStatus"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.bonusRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FiGift /> {bonus}</button>
                                <button
                                    value="canceled"
                                    name="paymentStatus"
                                    className="btn btn-outline-success payment-btn"
                                    ref={(ref) => this.canceledRef = ref}
                                    onClick={(e) => this.inputHandler(e)}
                                ><FiX className="text-danger" /> {canceled}</button>
                            </div>
                            <div style={{ display: this.state.paymentStatus === 'debt' ? 'block' : 'none' }} id="customer-details">
                                <h5>{ctTitle}</h5>
                                <input
                                    type="text"
                                    name="customerName"
                                    className="form-control"
                                    placeholder={ctName}
                                    defaultValue={this.state.customerName}
                                    onChange={(e) => this.customerHandler(e)}
                                />
                                <input
                                    type="number"
                                    name="customerDebtAmount"
                                    className="form-control mt-3"
                                    placeholder={ctDue}
                                    defaultValue={this.state.dueAmount}
                                    onChange={(e) => this.customerHandler(e)}
                                />
                                <input
                                    type="text"
                                    name="customerPhone"
                                    className="form-control mt-3"
                                    placeholder={ctPhone}
                                    defaultValue={this.state.customerPhone}
                                    onChange={(e) => this.customerHandler(e)}
                                />
                                <input
                                    type="text"
                                    name="customerAddress"
                                    className="form-control mt-3"
                                    placeholder={ctAddress}
                                    defaultValue={this.state.customerAddress}
                                    onChange={(e) => this.customerHandler(e)}
                                />
                                <DayPickerInput
                                    ref={(ref) => this.customerPayDeadline = ref}
                                    onDayChange={(date) => this.setState({ customerPayDeadline: new Date(date).getTime() })}
                                    dayPickerProps={{
                                        disabledDays: {
                                            before: new Date()
                                        }
                                    }}
                                    value={new Date(this.state.customerPayDeadline)}
                                />
                            </div>
                            <h5 onClick={this.toggleNoteDetails} className="text-left mt-2">{paymentTitle3} <FiEdit className="text-success" /> </h5>
                            <div className="form-group mt-3" style={{ display: this.state.noteBtn ? 'block' : 'none' }}>
                                <textarea
                                    className="form-control"
                                    placeholder={noteText}
                                    name="note"
                                    value={this.state.note}
                                    onChange={(e) => this.inputHandler(e)}
                                    rows="5"
                                />
                            </div>
                            <div className="mt-4 border-top pt-3">
                                {
                                    this.state.piecesForSale > 0 && this.state.salePrice >= this.state.totalMerchantPrice || this.state.paymentStatus === 'canceled' ?
                                        (<button
                                            className="btn btn-lg btn-success"
                                            onClick={(event) => this.formhandler(event)}
                                        >
                                            {button} {this.props.user.currency === 'UZS' ? parseInt(this.state.totalValue).toLocaleString() : this.state.totalValue} <sup>{this.props.user.currency}</sup>
                                        </button>)
                                        :
                                        null
                                }

                            </div>
                            <button
                                id="sale-page-next"
                                className="btn btn-sm btn-outline-secondary"
                                name="payment"
                                onClick={(e) => this.toggleSalePage(e)}
                            >{backBtn}</button>
                        </div>
                        <div id="sale-product-details" style={{ display: detail ? 'block' : 'none' }} className="text-left">
                            <h3 className="mt-3 mb-0"><span className="text-uppercase">{this.state.name}</span> </h3>
                            <p className="border-bottom company-name">{this.state.brand}</p>
                            <h5>{title}</h5>
                            <table className="table table-sm table-bordered">
                                <tbody>
                                    <tr>
                                        <td>{design}:</td>
                                        <th><span className="main-info">{this.state.code}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{quality}:</td>
                                        <th className="text-capitalize"><span className="main-info">{this.state.quality}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{category}:</td>
                                        <th className="text-capitalize"><span className="main-info">{this.state.category}</span></th>
                                    </tr>
                                    <tr>
                                        <td>{color}:</td>
                                        <th id="color-th"><span className="main-info">{this.state.color}</span> <span className="color-style" style={{ background: this.state.colorCode }}></span></th>
                                    </tr>
                                    <tr>
                                        <td>{dimension}:</td>
                                        <th><span className="main-info">{this.state.width}</span> x <span className="main-info">{this.state.lengthLong}</span> m</th>
                                    </tr>
                                    <tr>
                                        <td>{total} m<sup>2</sup>:</td>
                                        <th><span className="main-info">{this.state.totalSize}</span> m<sup>2</sup> </th>
                                    </tr>
                                    <tr>
                                        <td>{importPrice}:</td>
                                        <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.factoryPrice * uzsAmount).toLocaleString() : this.state.factoryPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                    </tr>
                                    <tr>
                                        <td>{salePrice}:</td>
                                        <th><span className="main-info">{this.props.user.currency === 'UZS' ? parseInt(this.state.merchantPrice * uzsAmount).toLocaleString() : this.state.merchantPrice}</span> {this.props.user.currency}/m<sup>2</sup></th>
                                    </tr>
                                    <tr>
                                        <td>{inStock}:</td>
                                        <th><span className="main-info">{this.state.piece}</span></th>
                                    </tr>
                                </tbody>

                            </table>
                            <h5 className="my-3">{info}</h5>
                            <p>
                                {this.state.content}
                            </p>

                            <Receipt
                                logo={this.props.user.img}
                                user={{ ...this.props.user }}
                                {...this.state}
                                ref={ref => this.receiptRef = ref}
                            />
                            <ReactToPrint
                                trigger={() => <button className="d-none"></button>}
                                content={() => this.receiptRef}
                                ref={ref => this.printerRef = ref}
                                onAfterPrint={() => {
                                    Swal.fire({
                                        type: 'success',
                                        title: 'Sold Successfully',
                                        showConfirmButton: false,
                                        timer: 1500
                                    });
                                    setTimeout(() => this.props.history.push('/sales'), 2000)
                                }}
                            />

                            <button
                                name="sale"
                                className="btn btn-warning"
                                onClick={this.toggleSaleDetailsTab}
                            >{saleBtn}</button>
                        </div>
                    </div>
                </div>
            </div >
        )


    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        products: state.products.products,
        sales: state.sales.sales,
        currency: state.currency
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateSale: (product) => dispatch(updateSale(product)),
        updateProduct: (product) => dispatch(updateProduct(product)),
        createNotification: (data) => dispatch(createNotification(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewSale));